import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('container') as HTMLElement);

root.render(<App />);

serviceWorker.unregister();
